import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const token = () => localStorage.getItem('token');
const apiGet = (p) => fetch(`/${p}${p.includes('?') ? '&' : '?'}_=${Date.now()}`, { headers: { Authorization: `Bearer ${token()}`, 'Cache-Control': 'no-cache' } }).then(r => r.json());
const apiSend = (p, m, b) => fetch(`/${p}`, { method: m, headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` }, body: b ? JSON.stringify(b) : undefined }).then(r => r.json());

const th = { padding: '5px 10px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: '#fff', textTransform: 'uppercase', letterSpacing: '0.04em', background: '#0a1628', whiteSpace: 'nowrap' };
const td = { padding: '4px 10px', fontSize: 13, color: '#374151', borderBottom: '1px solid #e8eaed' };
const inp = { padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 12, color: '#111', background: '#fff', height: 26, outline: 'none' };
const moeda = (v) => (v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
const soDig = (t) => (t || '').replace(/\D/g, '');
function fmtDoc(f) {
  const cnpj = soDig(f.cnpj), cpf = soDig(f.cpf);
  if (cnpj.length === 14) return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  if (cpf.length === 11) return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  return f.cnpj || f.cpf || '—';
}

export default function Fornecedores() {
  const navigate = useNavigate();
  const [lista, setLista] = useState([]);
  const [totais, setTotais] = useState({});
  const [busca, setBusca] = useState('');
  const [carregando, setCarregando] = useState(true);
  const [confirmar, setConfirmar] = useState(null);

  const carregar = useCallback(async () => {
    setCarregando(true);
    try {
      const [forns, fin] = await Promise.all([
        apiGet(`fornecedores${busca ? `?busca=${encodeURIComponent(busca)}` : ''}`),
        apiGet('financeiro?tipo=pagar'),
      ]);
      setLista(Array.isArray(forns) ? forns : []);
      const map = {};
      (fin?.itens || []).forEach(it => {
        if (it.fornecedor_id && it.status === 'aberto') map[it.fornecedor_id] = (map[it.fornecedor_id] || 0) + it.valor;
      });
      setTotais(map);
    } catch { /* silencioso */ }
    setCarregando(false);
  }, [busca]);

  useEffect(() => { const t = setTimeout(carregar, 250); return () => clearTimeout(t); }, [carregar]);

  const excluir = async () => {
    const id = confirmar._id; setConfirmar(null);
    await apiSend(`fornecedores/${id}`, 'DELETE');
    carregar();
  };

  return (
    <div style={{ padding: 4 }}>
      {confirmar && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={() => setConfirmar(null)}>
          <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 12, padding: 28, maxWidth: 400, width: '90%', textAlign: 'center', boxShadow: '0 20px 60px rgba(0,0,0,0.25)' }}>
            <div style={{ fontSize: 40, marginBottom: 10 }}>⚠️</div>
            <p style={{ fontSize: 14, color: '#374151', marginBottom: 20 }}>Excluir o fornecedor <b>{confirmar.nome || confirmar.razao_social}</b>? As contas a pagar vinculadas a ele também serão removidas.</p>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
              <button onClick={() => setConfirmar(null)} style={{ ...inp, height: 34, cursor: 'pointer' }}>Cancelar</button>
              <button onClick={excluir} style={{ background: '#dc2626', color: '#fff', border: 'none', borderRadius: 4, padding: '0 18px', height: 34, fontWeight: 600, cursor: 'pointer' }}>Excluir</button>
            </div>
          </div>
        </div>
      )}

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8, marginBottom: 10 }}>
        <div>
          <h1 style={{ fontSize: 16, fontWeight: 700, color: '#0a1628', margin: 0 }}>🏭 Fornecedores</h1>
          <p style={{ fontSize: 12, color: '#6b7280', margin: '1px 0 0' }}>{lista.length} fornecedor(es)</p>
        </div>
        <div style={{ display: 'flex', gap: 6 }}>
          <button onClick={() => navigate('/financeiro')} style={{ ...inp, cursor: 'pointer', height: 28 }}>← Financeiro</button>
          <button onClick={() => navigate('/fornecedores/novo')} style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 4, padding: '5px 14px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>+ Cadastrar novo</button>
        </div>
      </div>

      <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar por nome, CNPJ, CPF ou contato..." style={{ ...inp, width: '100%', maxWidth: 360, boxSizing: 'border-box', marginBottom: 10 }} />

      {carregando ? (
        <div style={{ textAlign: 'center', padding: 30, color: '#6b7280', fontSize: 13 }}>Carregando...</div>
      ) : lista.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 40, background: '#fff', border: '1px solid #c8d0da', borderRadius: 4, color: '#6b7280', fontSize: 13 }}>
          {busca ? 'Nenhum fornecedor encontrado.' : 'Nenhum fornecedor cadastrado ainda.'}
        </div>
      ) : (
        <div style={{ border: '1px solid #c8d0da', borderRadius: 4, overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff' }}>
            <thead>
              <tr>
                {['Nome / Razão social', 'CNPJ / CPF', 'Telefone', 'Contato', 'A pagar (aberto)', 'Ações'].map((h, i) => (
                  <th key={i} style={{ ...th, textAlign: i === 4 ? 'right' : 'left' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {lista.map((f, i) => (
                <tr key={f._id} style={{ background: i % 2 === 0 ? '#fff' : '#fafafa' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#f0f4ff'}
                  onMouseLeave={e => e.currentTarget.style.background = i % 2 === 0 ? '#fff' : '#fafafa'}>
                  <td style={{ ...td, fontWeight: 600, color: '#111' }}>{f.nome || f.razao_social || '—'}</td>
                  <td style={{ ...td, fontFamily: 'monospace' }}>{fmtDoc(f)}</td>
                  <td style={td}>{f.telefone || '—'}</td>
                  <td style={td}>{f.responsavel || '—'}</td>
                  <td style={{ ...td, textAlign: 'right', fontWeight: 600, color: totais[f._id] ? '#b91c1c' : '#9ca3af' }}>{totais[f._id] ? moeda(totais[f._id]) : '—'}</td>
                  <td style={{ ...td, whiteSpace: 'nowrap' }}>
                    <button onClick={() => navigate(`/fornecedores/${f._id}/editar`)} style={{ ...inp, height: 24, cursor: 'pointer', marginRight: 4 }}>Abrir</button>
                    <button onClick={() => setConfirmar(f)} style={{ background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca', borderRadius: 3, padding: '2px 8px', fontSize: 11, cursor: 'pointer' }}>Excluir</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
